import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="bg-background w-full flex flex-col justify-evenly items-center h-32 text-primary">
      <Link to="/privacy_policy">
        <p className="underline">Privacy Policy</p>
      </Link>
      <Link to="/terms_of_service">
        <p className="underline">Terms of Service</p>
      </Link>
      <p className="text-center">
        Copyright (©) 2024 playguru.app by Wouter Ensink & Marc Groenewegen
      </p>
    </div>
  );
}
